import { A as A11y, N as Navigation, S as Swiper } from './a11y-xGUUM7Li.js';
import { A as Autoplay, P as Pagination, S as Scrollbar } from './autoplay-DIKmlMH5.js';

if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-swiper]');

      this.swiperOptions = {
        modules: [A11y, Autoplay, Navigation, Pagination, Scrollbar],
        threshold: 10,
      };

      // Check if we have extra options on the HTML
      if (this.swiperElement.dataset && this.swiperElement.dataset.options) {
        const jsonOptions = JSON.parse(this.swiperElement.dataset.options);

        if (jsonOptions) {
          this.swiperOptions = {
            ...this.swiperOptions,
            ...jsonOptions,
          };
        }
      }

      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

      // BELANGRIJK: hier stond eerder `window.onload = () => this.init()`.
      // Dat is een toewijzing, geen listener. Staan er twee van deze secties
      // op een pagina, dan overschreef de tweede de eerste en haalde alleen
      // de laatste zijn aanbevelingen op. Vandaar addEventListener, plus een
      // directe aanroep als de pagina al geladen is.
      if (document.readyState === 'complete') {
        this.init();
      } else {
        window.addEventListener('load', () => this.init(), { once: true });
      }
    }

    // Verberg de hele sectie als er niets te tonen valt, zodat er nooit een
    // lege slider met alleen een titel achterblijft.
    toggleEmptyState() {
      const host = this.closest('.product-recommendation-section') || this;
      const lijst = this.querySelector('[data-recommended-products]');
      const aantal = lijst ? lijst.querySelectorAll('.swiper-slide').length : 0;
      host.style.display = aantal === 0 ? 'none' : '';
    }

    init() {
      this.toggleEmptyState();

      if (this.dataset && this.dataset.url) {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const bron = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('[data-recommended-products]');

            this.querySelector('[data-recommended-products]').innerHTML = bron ? bron.innerHTML : '';

            this.toggleEmptyState();

            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
            if (this.swiperOptions.pagination) {
              this.swiperInstance.pagination.init();
              this.swiperInstance.pagination.update();
            }
            if (this.swiperOptions.scrollbar) {
              this.swiperInstance.scrollbar.init();
              this.swiperInstance.scrollbar.updateSize();
            }
          })
          .catch((error) => {
            console.error(error);
            this.toggleEmptyState();
          });
      }
    }
  }

  window.ProductRecommendations = ProductRecommendations;

  customElements.define('product-recommendations', ProductRecommendations);
}
